import { render } from "./planejamento_config.vue?vue&type=template&id=c5a7bbea&scoped=true"
import script from "./planejamento_config.vue?vue&type=script&lang=js"
export * from "./planejamento_config.vue?vue&type=script&lang=js"

import "./planejamento_config.vue?vue&type=style&index=0&id=c5a7bbea&lang=scss&scoped=true"
import "./planejamento_config.vue?vue&type=style&index=1&id=c5a7bbea&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5a7bbea"]])

export default __exports__